import React from "react";
import { ClockCounterClockwise } from "@phosphor-icons/react";

export default function StaleDataBanner({ cachedAt }) {
  if (!cachedAt) return null;
  const when = new Date(cachedAt).toLocaleString("en-AU", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  return (
    <div data-testid="stale-data-banner"
      className="flex items-center justify-center gap-2 bg-gray-700 text-white text-xs font-semibold text-center py-1.5 px-3">
      <ClockCounterClockwise size={14} weight="bold" /> Offline — showing saved data from {when}
    </div>
  );
}
